/**
 * Brand identity for the respondent app, apart from colours, which live in
 * tokens.css beside this file. Together the two files are the theme layer.
 *
 * A rebrand edits this object and drops the assets it names into
 * public/brand/. Nothing else in the app names a brand.
 */

export interface BrandLogo {
  /** Served from public/. Vector, so the header is sharp at any density. */
  readonly src: string;
  /** Intrinsic aspect, used to reserve space before the file arrives. */
  readonly width: number;
  readonly height: number;
  /** Alternative text. The organisation name, nothing more. */
  readonly alt: string;
}

export interface Brand {
  /** The organisation the respondent is answering for. */
  readonly name: string;
  /** What this instrument is called on screen and in the browser tab. */
  readonly product: string;
  /** Short name for the web app manifest and home-screen icon. */
  readonly shortName: string;
  /** Header logo, or null to show `name` as text. */
  readonly logo: BrandLogo | null;
}

export const BRAND: Brand = {
  name: 'DNA Behavior',
  product: 'DNA Behavior Discovery',
  shortName: 'Discovery',
  // The primary wordmark from the official pack, as vector. See the file's
  // own header for where it came from.
  logo: { src: '/brand/logo.svg', width: 555, height: 76, alt: 'DNA Behavior' },
};
